
import { Component, Vue } from 'vue-property-decorator'
import appBar from '@/components/AppBar.vue'
import { Authority } from '../models/Authority'
import { MonthlyTabulationList } from '../models/MonthlyTabulationList'
import { Const } from '../scripts/Const'
import { MsgConst } from '../scripts/MsgConst'
import { StringUtil } from '../scripts/StringUtil'
import { SearchCondition } from '../models/MonthlyTabulationListSearchCondition'

@Component({
	components: { appBar }
})
export default class MonthlyTabulationView extends Vue {
	//#region 変数
    private authority: Authority = new Authority()
	private search = ''
	private menuFrom = false
	private menuTo = false
	private searchCondition: SearchCondition = new SearchCondition()
	//#region メッセージ
	private showMessage = false
	private messageType = 'info'
	private message = ''
	//#endregion

    //#region 表示制御
    private showExportNormalExcel = false
    private showExportPayrollExcel = false
	//#endregion

	private monthlytabulationList: MonthlyTabulationList[] = []
	private headers = [
		{
			text: '年月',
			value: 'workingYm',
			width: '4%',
			class: 'sticky-header sticky1 row-z primary white--text px-1',
			divider: true,
			align: 'center'
		},
		{
			text: '雇用形態',
			value: 'empTypeNm',
			width: '4%',
			class: 'sticky-header sticky2 row-z primary white--text px-1',
			divider: false,
			align: 'center'
		},
		{
			text: 'ID',
			value: 'empCd',
			width: '4%',
			class: 'sticky-header sticky3 row-z primary white--text px-1',
			divider: true,
			align: 'center'
		},
		{
			text: '氏名',
			value: 'empNm',
			width: '4%',
			class: 'sticky-header sticky4 row-z primary white--text px-1',
			divider: true,
			sortable: false,
			align: 'center'
		},
		{
			text: 'ステータス',
			value: 'status',
			width: '4%',
			class: 'sticky-header primary white--text px-1',
			divider: true,
			align: 'center'
		},
		{
			text: '所属',
			value: 'divisionNm',
			width: '4%',
			class: 'sticky-header primary white--text px-1',
			divider: true,
			align: 'center'
		},
		{
			text: '既定日数',
			value: 'daycntDefault',
			width: '3%',
			class: 'sticky-header primary white--text px-1',
			divider: true,
			sortable: false,
			align: 'center'
		},
		{
			text: '出勤日数',
			value: 'daycntTotal',
			width: '3%',
			class: 'sticky-header primary white--text px-1',
			divider: true,
			sortable: false,
			align: 'center'
		},
		{
			text: '休出',
			value: 'daycntHoliday',
			width: '3%',
			class: 'sticky-header primary white--text px-1',
			divider: true,
			sortable: true,
			align: 'center'
		},
		{
			text: '振休発生',
			value: 'daycntCanExchange',
			width: '3%',
			class: 'sticky-header primary white--text px-1',
			divider: true,
			sortable: false,
			align: 'center'
		},
		{
			text: '有給',
			value: 'daycntPaidVacation',
			width: '3%',
			class: 'sticky-header primary white--text px-1',
			divider: true,
			sortable: false,
			align: 'center'
		},
		{
			text: '振休',
			value: 'daycntExchange',
			width: '3%',
			class: 'sticky-header primary white--text px-1',
			divider: true,
			sortable: false,
			align: 'center'
		},
		{
			text: '特休',
			value: 'daycntSpecialHoliday',
			width: '3%',
			class: 'sticky-header primary white--text px-1',
			divider: true,
			sortable: false,
			align: 'center'
		},
		{
			text: '欠勤',
			value: 'daycntAdsence',
			width: '3%',
			class: 'sticky-header primary white--text px-1',
			divider: true,
			sortable: true,
			align: 'center'
		},
		{
			text: '遅刻時間',
			value: 'lateTime',
			width: '4%',
			class: 'sticky-header primary white--text px-1',
			divider: true,
			sortable: false,
			align: 'center'
		},
		{
			text: '遅刻回数',
			value: 'lateCnt',
			width: '3%',
			class: 'sticky-header primary white--text px-1',
			divider: true,
			sortable: true,
			align: 'center'
		},
		{
			text: '早退時間',
			value: 'earlyTime',
			width: '4%',
			class: 'sticky-header primary white--text px-1',
			divider: true,
			sortable: false,
			align: 'center'
		},
		{
			text: '早退回数',
			value: 'earlyCnt',
			width: '3%',
			class: 'sticky-header primary white--text px-1',
			divider: true,
			sortable: true,
			align: 'center'
		},
		{
			text: '稼働',
			value: 'wktimeActual',
			width: '4%',
			class: 'sticky-header primary white--text px-1',
			divider: true,
			sortable: false,
			align: 'center'
		},
		{
			text: '残業',
			value: 'overA',
			width: '4%',
			class: 'sticky-header success white--text px-1',
			divider: true,
			sortable: true,
			align: 'center'
		},
		{
			text: '深夜',
			value: 'overB',
			width: '4%',
			class: 'sticky-header success white--text px-1',
			divider: true,
			sortable: true,
			align: 'center'
		},
		{
			text: '法定',
			value: 'houA',
			width: '4%',
			class: 'sticky-header success white--text px-1',
			divider: true,
			sortable: true,
			align: 'center'
		}
	]
	private selectedEmp: MonthlyTabulationList = new MonthlyTabulationList()

	//#endregion

	// #region 初期表示
	private async created() {

		if (this.$route.params.dateFrom == null) {
			//既定値は空欄で検索指示する。ロジック側で締済で最も古い月設定
		} else {
			this.searchCondition.dateFrom = this.$route.params.dateFrom
		}
		if (this.$route.params.dateTo == null) {
			//既定値は空欄で検索指示する。ロジック側で締済で最も古い月設定
		} else {
			this.searchCondition.dateTo = this.$route.params.dateTo
		}
		this.search = this.$route.params.searchString
		//メッセージ
		this.clearMessage()

		this.getList()
		//画面上部へスクロール
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}
	//#endregion

	//#region 年月変更
	private changeYm() {
		//初期化
		//メッセージ
		this.clearMessage()

		//取得処理の実行
		this.getList()

	}
	//#endregion

	//#region 行クリック
	private clickRow(workingYm: string, empCd: string) {

		this.$router.push({
			name: 'WorkingList',
			params: {
				workingYm: workingYm.replace('/', ''),
				empCd: empCd,
				beforeViewName: 'MonthlyTabulation',
				beforeViewParam1: this.searchCondition.dateFrom,
				beforeViewParam2: this.searchCondition.dateTo,
				beforeViewParam3: this.search
			}
		})
	}
	//#endregion

    //#region 汎用Excelエクスポートクリック
    private clickExportNormalExcel() {
        this.exportNormalExcel()
    }
	//#endregion

	//#region 給与計算用Excelエクスポートクリック
    private clickExportPayrollExcel() {
        this.exportPayrollExcel()
    }
	//#endregion

    //#region 定期代Excelエクスポートクリック
    private clickTrainPassExcel() {
        this.exportTrainPassExcel()
    }
	//#endregion

    //#region 経費Excelエクスポートクリック
    private clickCostExcel() {
        this.exportCostExcel()
    }
	//#endregion


	//#region プライベート
	//#region 月別集計表取得
	private async getList() {
		try {
			this.monthlytabulationList = []			//検索結果無しのときに過去分が出ないように初期化

			//出力ボタン初期化(非表示化)
            this.showExportNormalExcel = false		
			this.showExportPayrollExcel = false		

			const data = { SearchCondition: this.searchCondition }

			const response = await this.$axios.post('api/MonthlyTabulation/Search', data)

            this.searchCondition.dateFrom = response.data.searchCondition.dateFrom	//年月Fromに未締の最も古い月セット
            this.searchCondition.dateTo = response.data.searchCondition.dateTo	//年月Fromに未締の最も古い月セット

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				console.log(response.data.messageData)
				return
			}
			this.monthlytabulationList = response.data.searchResult

            //権限
			this.authority = response.data.authority

			if (
				(
					this.authority.roleWorkingHoursAdmin
					|| this.authority.roleBusinessAdmin
					|| this.authority.roleManager
				)
				&& this.message == ''
            ) {
                this.showExportNormalExcel = true
            }


            var closingData = this.monthlytabulationList.filter((x) => x.status == '締済' || x.status == '締済(交)' )
			if (
                this.authority.roleWorkingHoursAdmin
                && (this.searchCondition.dateFrom == this.searchCondition.dateTo)
				&& closingData.length > 0
			)
			{
                this.showExportPayrollExcel = true
            }


		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion
	//#region エラーメッセージ
	private errorMessage(message: string) {
		this.showMessage = true
		this.messageType = 'error'
		this.message = message
	}
	//#endregion

	//#region メッセージクリア
	private clearMessage() {
		this.message = ''
		this.showMessage = false
	}
	//#endregion

    // #region 一覧再描画ボタン押下
    private refresh() {
        this.getList()
    }
	//#endregion

    // #region 汎用用Excelエクスポートボタン押下
    private async exportNormalExcel() {
        var nowDate = new Date()
        var year = nowDate.getFullYear()
        var month = ("0" + (nowDate.getMonth() + 1)).slice(-2)
        var date = ("0" + nowDate.getDate()).slice(-2)
        var hour = ("0" + nowDate.getHours()).slice(-2)
        var min = ("0" + nowDate.getMinutes()).slice(-2)
        var sec = ("0" + nowDate.getSeconds()).slice(-2)
        var filename = '月別集計表_' + year + month + date + '_' + hour + min + sec + '.xlsx'
        this.clearMessage()

        try {
            await this.$axios({
                url: 'api/MonthlyTabulation/ExportNormalExcel',
                method: 'GET',
                params: {
                    targetYmFrom: this.searchCondition.dateFrom,
                    targetYmTo: this.searchCondition.dateTo,
                },
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
            });

        } catch (error) {
			this.showMessage = true
			this.message = StringUtil.stringFormat(MsgConst.COMMON.ERROR_004,'出力')
            this.messageType = 'error'
        }

    }
	//#endregion

    // #region 給与計算用Excelエクスポートボタン押下
    private async exportPayrollExcel() {
        var nowDate = new Date()
        var year = nowDate.getFullYear()
        var month = ("0" + (nowDate.getMonth() + 1)).slice(-2)
        var date = ("0" + nowDate.getDate()).slice(-2)
        var hour = ("0" + nowDate.getHours()).slice(-2)
        var min = ("0" + nowDate.getMinutes()).slice(-2)
        var sec = ("0" + nowDate.getSeconds()).slice(-2)
        var filename = '給与計算シート_' + year + month + date + '_' + hour + min + sec + '.xlsx'
		this.clearMessage()

		try {
            await this.$axios({
                url: 'api/MonthlyTabulation/ExportPayrollExcel',
                method: 'GET',
                params: {
                    targetYmFrom: this.searchCondition.dateFrom,
                    targetYmTo: this.searchCondition.dateTo,
                },
                responseType: 'blob', // important
			}).then((response) => {
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', filename);
					document.body.appendChild(link);
					link.click();
            });

		} catch (error) {
            this.showMessage = true
            this.message = StringUtil.stringFormat(MsgConst.COMMON.ERROR_004, '出力')
            this.messageType = 'error'
        }

    }
	//#endregion

    // #region 定期代Excelエクスポートボタン押下
    private async exportTrainPassExcel() {
        var nowDate = new Date()
        var year = nowDate.getFullYear()
        var month = ("0" + (nowDate.getMonth() + 1)).slice(-2)
        var date = ("0" + nowDate.getDate()).slice(-2)
        var hour = ("0" + nowDate.getHours()).slice(-2)
        var min = ("0" + nowDate.getMinutes()).slice(-2)
		var sec = ("0" + nowDate.getSeconds()).slice(-2)
		var filename = '定期代一覧_' + StringUtil.changeMonth(this.searchCondition.dateFrom.replace('-', ''), 1) + '_' + year + month + date + hour + min + sec + '.xlsx'
        this.clearMessage()

        try {
            await this.$axios({
                url: 'api/MonthlyTabulation/ExportTrainPassExcel',
                method: 'GET',
                params: {
                    targetYmFrom: this.searchCondition.dateFrom,
                    targetYmTo: this.searchCondition.dateTo,
                },
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
            });

        } catch (error) {
            this.showMessage = true
            this.message = StringUtil.stringFormat(MsgConst.COMMON.ERROR_004, '出力')
            this.messageType = 'error'
        }

    }
	//#endregion

    // #region 経費Excelエクスポートボタン押下
    private async exportCostExcel() {
        var nowDate = new Date()
        var year = nowDate.getFullYear()
        var month = ("0" + (nowDate.getMonth() + 1)).slice(-2)
        var date = ("0" + nowDate.getDate()).slice(-2)
        var hour = ("0" + nowDate.getHours()).slice(-2)
        var min = ("0" + nowDate.getMinutes()).slice(-2)
        var sec = ("0" + nowDate.getSeconds()).slice(-2)
        var filename = '経費代一覧_' + this.searchCondition.dateFrom.replace('-', '') + '_' + year + month + date + hour + min + sec + '.xlsx'
        this.clearMessage()

        try {
            await this.$axios({
                url: 'api/MonthlyTabulation/ExportCostExcel',
                method: 'GET',
                params: {
                    targetYmFrom: this.searchCondition.dateFrom,
                    targetYmTo: this.searchCondition.dateTo,
                },
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
            });

        } catch (error) {
            this.showMessage = true
            this.message = StringUtil.stringFormat(MsgConst.COMMON.ERROR_004, '出力')
            this.messageType = 'error'
        }

    }
	//#endregion
	//#endregion
}
